import _ from 'lodash'

const toRupiah = (amount) => {
  if(!amount) return '0'
  return _.toNumber(amount).toLocaleString('id-ID')
}

export default toRupiah